export default __webpack_public_path__ + "static/media/thumb-GNSS-Receiver-3.6b300438.png";